<template>
  <div class="action-bar">
    <div v-if="showVariablePicker" class="variable-picker" v-click-away="closeVariablePicker">
      <CodeIcon
        class="icon-1-2x action-icon code-icon"
        :class="{ clicked: isVariablePickerOpen }"
        @click="isVariablePickerOpen = !isVariablePickerOpen"
      ></CodeIcon>
      <VariablePicker
        class="dropdown-trigger"
        direction="left"
        :readonly="true"
        :open="isVariablePickerOpen"
        :showButton="false"
        @variable-selected="addVariableToText"
        :additional-attributes="getNameAttributes()"
      />
    </div>
    <div class="emoji-picker-and-icon" v-click-away="closeEmojiPicker">
      <EmojiIcon
        class="icon-1-2x emoji-icon action-icon"
        :class="{ clicked: isEmojiPickerOpen }"
        @click="toggleEmojiPicker"
      ></EmojiIcon>
      <EmojiPicker @insertEmoji="insertEmoji" :show="isEmojiPickerOpen"> </EmojiPicker>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { InputVariableViewModel } from '@/features/bots/models/designer';
import EmojiIcon from 'vue-material-design-icons/EmoticonHappyOutline.vue';
import EmojiPicker from '@/features/bots/components/designer/TextEditor/EmojiPicker.vue';
import VariablePicker from '@/features/bots/components/designer/VariablePicker/VariablePicker.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';

defineProps({
  showVariablePicker: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (e: 'addVariable', variable: InputVariableViewModel): void;
  (e: 'addEmoji', emoji: string): void;
}>();

const store = useStore();
const flowVariables = computed<InputVariableViewModel[]>(() => store.getters.flowVariables);

const isVariablePickerOpen = ref(false);
const isEmojiPickerOpen = ref(false);

function addVariableToText(variable: InputVariableViewModel) {
  isVariablePickerOpen.value = false;
  emit('addVariable', variable);
}

function insertEmoji(emoji: any) {
  closeEmojiPicker();
  emit('addEmoji', emoji.native);
}

function closeEmojiPicker() {
  isEmojiPickerOpen.value = false;
}

function toggleEmojiPicker() {
  isEmojiPickerOpen.value = !isEmojiPickerOpen.value;
  if (isEmojiPickerOpen.value) {
    isVariablePickerOpen.value = false;
  }
}

function closeVariablePicker() {
  isVariablePickerOpen.value = false;
}

function getNameAttributes(): InputVariableViewModel[] {
  const firstName = {
    key: 'givenName',
    id: 'givenName',
    scope: 'appUser',
    dataType: 'text',
    name: 'First Name',
  } as InputVariableViewModel;

  const secondName = {
    key: 'surname',
    id: 'surname',
    scope: 'appUser',
    dataType: 'text',
    name: 'Last Name',
  } as InputVariableViewModel;

  return [firstName, secondName];
}
</script>

<style scoped lang="scss">
.action-bar {
  position: relative;
  height: 25px;
  margin-top: 5px;
  display: flex;
}

.emoji-picker-and-icon {
  position: relative;
}
.emoji-icon {
  padding-left: 3px;
  position: absolute;
}

.action-icon {
  color: rgba(10, 10, 10, 0.4);

  &:hover {
    color: rgba(10, 10, 10, 0.8);
    cursor: pointer;
  }
}

.clicked {
  color: rgba(10, 10, 10, 0.8);
}

:deep(.dropdown-menu) {
  left: -15px;
}
</style>
